import React from 'react';
import DividerWithText from '../../DividerWithText/DividerWithText';
import styles from '../constants/styles';
import { Typography } from '@material-ui/core';
import LearningPlanAvailable from './LearningPlanAvailable';
import { useTranslation } from 'react-i18next';
import { textToSnakeCase } from '../../../utils/utils';
import { RootStateOrAny, useSelector } from 'react-redux';

const LearningPlansList = ({ attributes }) => {
  const classes = styles();
  const { t } = useTranslation();
  const categories: string[] = [];

  const { brand, Region, CountryId } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  attributes.forEach(attribute => {
    if (categories.includes(attribute.categoryCode)) {
      return;
    }

    categories.push(attribute.categoryCode);
  });

  return (
    <div>
      {categories &&
        categories.map(category => {
          return (
            <div>
              <DividerWithText>
                <Typography variant="subtitle2">
                  {t(`restaurant.categoriesAndServices.${category}`)}
                </Typography>
              </DividerWithText>
              <div
                className={classes.flexSpaceBetween}
                style={{ padding: '1em' }}
              >
                {attributes.map(attribute => {
                  let name = t(
                    `restaurant.attributes_and_services.${attribute.code}`,
                    attribute.name,
                  );

                  if (category != attribute.categoryCode) {
                    return;
                  }

                  if (
                    attribute.code === 'integratedFreshBrew' ||
                    attribute.code === 'avftVeggieWash' ||
                    attribute.code === 'delivery'
                  ) {
                    if (!(brand === 'TH' && Region === 'NA')) {
                      return;
                    }
                  }
                  //PBI -19614 - Adding new equipment to RAM: Sticky Label Printer
                  //Enable the stickyLabelPrinter only for BK - CAN/USA
                  if (
                    attribute.code === 'stickyLabelPrinter' &&
                    !(brand === 'BK' && (CountryId === 36 || CountryId === 212))
                  ) {
                    return;
                  }

                  if (attribute.type === 'enum') {
                    name = `${t(
                      `restaurant.attributes_and_services.${attribute.code}`,
                      attribute.name,
                    )}:  ${
                      attribute.value
                        ? t(
                            `restaurant.attributes_and_services.${textToSnakeCase(
                              attribute.value || '',
                            )}`,
                            attribute.value || '',
                          )
                        : ''
                    }`;
                  }

                  return (
                    <LearningPlanAvailable
                      name={name}
                      value={attribute.value}
                      showIcon={attribute.type == 'toggle'}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default LearningPlansList;
